/**
 * 
 */
export const config = {
        mastercraft: {
            brandLogo: "MasterCraft/MC_Logo.svg",
            brandName: "MasterCraft",
            brandUrl: "https://mastercraft.com/",
            footerLogo: 'MasterCraft/logo.png',
            copyright: new Date().getFullYear() + " MasterCraft. All rights reserved.",
            socialMedia: [{
                    icon: 'fa-facebook',
                    label: 'Facebook',
                    url: 'https://www.facebook.com/MCBoatCompany',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-instagram',
                    label: 'Instagram',
                    url: 'https://www.instagram.com/mcboatcompany',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-twitter',
                    label: 'Twitter',
                    url: 'https://twitter.com/mcboatcompany',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-youtube',
                    label: 'Youtube',
                    url: 'https://www.youtube.com/user/MasterCraftBoats',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-linkedin',
                    label: 'Linkedin',
                    url: 'https://www.linkedin.com/company/mastercraft-boat-co-',
                    target: '_blank',
                    isActive: true
                }
            ],
            header: [
                //{
                //    name: 'Inventory',
                //    link: '/inventory',
                //    target: 'self',
                //    isActive: true,
                //    dropdown: true,
                //    dropdownLinks: [
                //        { name: 'New Boats', link: '/Inventory/New', dropdown: false },
                //        { name: 'Used Boats', link: '/Inventory/Used', dropdown: false },
                //    ],
                //},
                {
                    name: 'Inventory',
                    link: '/Inventory/New',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Design a Boat',
                    link: 'https://designmy.mastercraft.com',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                }, {
                    name: 'Trade-In',
                    link: '/Contact/TradeIn',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Parts & Service',
                    link: 'javascript:void(0)',
                    target: 'self',
                    isActive: true,
                    dropdown: true,
                    dropdownLinks: [
                        { name: 'MasterCraft', link: '/Contact/PartsService', dropdown: false },
                        { name: 'Ilmor', link: 'https://www.ilmor.com/results/1/inboard-stern-drive', target: "_blank", dropdown: false },
                    ],
                },
                {
                    name: 'Request Brochure',
                    link: '/Contact/RequestBrochure',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Apparel',
                    link: 'https://apparel.mastercraft.com',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Contact Us',
                    link: '/Contact/ContactUs',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                }
            ],
            footer: [{
                    title: 'Sales/Service',
                    menubar: [{
                            name: 'Inventory',
                            link: '/Inventory/New',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        }, {
                            name: 'Design a Boat',
                            link: 'https://designmy.mastercraft.com',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        }, {
                            name: 'Trade-In',
                            link: '/Contact/TradeIn',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Parts & Service',
                            link: '/Contact/PartsService',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Apparel',
                            link: 'https://apparel.mastercraft.com',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        },
                    ]
                },
                {
                    title: 'Company',
                    menubar: [{
                            name: 'Request Brochure',
                            link: '/Contact/RequestBrochure',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Contact Us',
                            link: '/Contact/ContactUs',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        }
                    ]
                }
            ],
            termCondition: [{
                    label: 'Terms & Conditions',
                    url: 'https://www.mastercraft.com/terms-and-conditions',
                    target: 'self',
                    isActive: true
                },
                {
                    label: 'Privacy Policy',
                    url: 'https://www.mastercraft.com/privacy-statement',
                    target: 'self',
                    isActive: true
                },
                // {
                    // label: 'Cookie Settings',
                    // url: 'javascript:showCookieBanner();',
                    // target: 'self',
                    // isActive: true
                // },
                {
                    label: 'Accessibility',
                    url: 'https://www.mastercraft.com/website-accessibility-statement',
                    target: 'self',
                    isActive: true
                }
            ],
            models: [{
                    value: 'NXT20',
                    label: 'NXT20'
                },
                {
                    value: 'NXT22',
                    label: 'NXT22'
                },
                {
                    value: 'NXT24',
                    label: 'NXT24'
                },
                {
                    value: 'XT20',
                    label: 'XT20'
                },
                {
                    value: 'XT21',
                    label: 'XT21'
                },
                {
                    value: 'XT22',
                    label: 'XT22'
                },
                {
                    value: 'XT23',
                    label: 'XT23'
                },
                {
                    value: 'XT24',
                    label: 'XT24'
                },
                {
                    value: 'XT25',
                    label: 'XT25'
                },
                {
                    value: 'X22',
                    label: 'X22'
                },
                {
                    value: 'X24',
                    label: 'X24'
                },
                {
                    value: 'X26',
                    label: 'X26'
                },
                {
                    value: 'XSTAR',
                    label: 'XSTAR'
                },
                {
                    value: 'XSTAR S',
                    label: 'XSTAR S'
                },
                {
                    value: 'PROSTAR',
                    label: 'PROSTAR'
                }
            ]
        },
        aviara: {
            brandLogo: "Aviara/aviara_logo.svg",
            brandName: "Aviara",
            brandUrl: "https://www.aviaraboats.com/",
            footerLogo: 'Aviara/aviara_logo.svg',
            copyright: new Date().getFullYear() + " Aviara. All rights reserved.",
            socialMedia: [{
                    icon: 'fa-facebook',
                    label: 'Facebook',
                    url: 'https://www.fb.me/aviaraboats',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-instagram',
                    label: 'Instagram',
                    url: 'https://www.instagram.com/aviaraboats/',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-twitter',
                    label: 'Twitter',
                    url: 'https://www.twitter.com/madebyaviara',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-youtube',
                    label: 'Youtube',
                    url: 'https://www.youtube.com/channel/UCr280ghO07V607sih-wp5HQ?',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-linkedin',
                    label: 'Linkedin',
                    url: 'https://www.linkedin.com/company/aviaraboats',
                    target: '_blank',
                    isActive: true
                }
            ],
            header: [
                //{
                //    name: 'Inventory',
                //    link: '/inventory',
                //    target: 'self',
                //    isActive: true,
                //    dropdown: true,
                //    dropdownLinks: [
                //        { name: 'New Boats', link: '/Inventory/New', dropdown: false },
                //        { name: 'Used Boats', link: '/Inventory/Used', dropdown: false },
                //    ],
                //},
                {
                    name: 'Inventory',
                    link: '/Inventory/New',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Design a Boat',
                    link: 'https://avapps.aviaraboats.com/',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Trade-In',
                    link: '/Contact/TradeIn',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Parts & Service',
                    link: '/Contact/PartsService',
                    target: 'self',
                    isActive: true,
                    dropdown: false
                },
                {
                    name: 'Request Brochure',
                    link: '/Contact/RequestBrochure',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'News & Events',
                    link: '/newsevents',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Contact Us',
                    link: '/Contact/ContactUs',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                }
            ],
            footer: [{
                    title: 'Sales/Service',
                    menubar: [{
                            name: 'Inventory',
                            link: '/Inventory/New',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        }, {
                            name: 'Design a Boat',
                            link: 'https://avapps.aviaraboats.com/',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        }, {
                            name: 'Trade-In',
                            link: '/Contact/TradeIn',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Parts & Service',
                            link: '/Contact/PartsService',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        },
                    ]
                },
                {
                    title: 'Company',
                    menubar: [{
                            name: 'Request Brochure',
                            link: '/Contact/RequestBrochure',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'News & Events',
                            link: '/newsevents',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Contact Us',
                            link: '/Contact/ContactUs',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        }
                    ]
                }
            ],
            termCondition: [{
                    label: 'Terms & Conditions',
                    url: 'https://www.aviaraboats.com/terms-and-condition',
                    target: 'self',
                    isActive: true
                },
                {
                    label: 'Privacy Policy',
                    url: 'https://www.aviaraboats.com/privacy-policy',
                    target: 'self',
                    isActive: true
                },
                // {
                    // label: 'Cookie Settings',
                    // url: 'javascript:showCookieBanner();',
                    // target: 'self',
                    // isActive: true
                // },
                {
                    label: 'Accessibility',
                    url: 'https://www.aviaraboats.com/accessibility-statement',
                    target: 'self',
                    isActive: true
                }
            ],
            models: [{
                    value: 'AV32',
                    label: 'AV32'
                },
                {
                    value: 'AV36',
                    label: 'AV36'
                },
                {
                    value: 'AV40',
                    label: 'AV40'
                }
            ]
        },
        crest: {
            brandLogo: "Crest/Crest_StackedLogo_CrestBlue_Web.svg",
            brandName: "Crest",
            brandUrl: "https://crestpontoonboats.com/",
            footerLogo: 'Crest/crest_stackedlogo_white_web.svg',
            copyright: new Date().getFullYear() + " Crest. All rights reserved.",
            socialMedia: [{
                    icon: 'fa-facebook',
                    label: 'Facebook',
                    url: 'https://www.facebook.com/CrestPontoonBoats',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-instagram',
                    label: 'Instagram',
                    url: 'https://www.instagram.com/crestpontoonboats/',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-youtube',
                    label: 'Youtube',
                    url: 'https://www.youtube.com/channel/UCzglRAozyb38ZqaDTSSXarw/videos',
                    target: '_blank',
                    isActive: true
                }
            ],
            header: [
                //{
                //    name: 'Inventory',
                //    link: '/inventory',
                //    target: 'self',
                //    isActive: true,
                //    dropdown: true,
                //    dropdownLinks: [
                //        { name: 'New Boats', link: '/Inventory/New', dropdown: false },
                //        { name: 'Used Boats', link: '/Inventory/Used', dropdown: false },
                //    ],
                //},
                {
                    name: 'Inventory',
                    link: '/Inventory/New',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Design a Boat',
                    link: 'https://build.crestpontoonboats.com',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Trade-In',
                    link: '/Contact/TradeIn',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Parts & Service',
                    link: '/Contact/PartsService',
                    target: 'self',
                    isActive: true,
                    dropdown: false
                },
                {
                    name: 'Request Brochure',
                    link: '/Contact/RequestBrochure',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                //{
                //    name: 'News & Events',
                //    link: '/newsevents',
                //    target: 'self',
                //    isActive: true,
                //    dropdown: false,
                //},
                {
                    name: 'Apparel',
                    link: 'https://apparel.crestpontoonboats.com/',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Contact Us',
                    link: '/Contact/ContactUs',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                }
            ],
            footer: [{
                    title: 'Sales/Service',
                    menubar: [{
                            name: 'Inventory',
                            link: '/Inventory/New',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        }, {
                            name: 'Design a Boat',
                            link: 'https://build.crestpontoonboats.com',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        }, {
                            name: 'Trade-In',
                            link: '/Contact/TradeIn',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Parts & Service',
                            link: '/Contact/PartsService',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        },
                        {
                            name: 'Apparel',
                            link: 'https://apparel.crestpontoonboats.com/',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        }
                    ]
                },
                {
                    title: 'Company',
                    menubar: [{
                            name: 'Request Brochure',
                            link: '/Contact/RequestBrochure',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        //{
                        //    name: 'News & Events',
                        //    link: '/newsevents',
                        //    target: 'self',
                        //    isActive: true,
                        //    dropdown: false,
                        //},
                        {
                            name: 'Contact Us',
                            link: '/Contact/ContactUs',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        }
                    ]
                }
            ],
            termCondition: [{
                    label: 'Terms & Conditions',
                    url: 'https://crestpontoonboats.com/terms-and-conditions',
                    target: 'self',
                    isActive: true
                },
                {
                    label: 'Privacy Policy',
                    url: 'https://crestpontoonboats.com/privacy-statement',
                    target: 'self',
                    isActive: true
                },
                // {
                    // label: 'Cookie Settings',
                    // url: 'javascript:showCookieBanner();',
                    // target: 'self',
                    // isActive: true
                // },
                {
                    label: 'Accessibility',
                    url: 'https://crestpontoonboats.com/website-accessibility-statement',
                    target: 'self',
                    isActive: true
                }
            ],
            models: [{
                    value: 'Caribbean LX',
                    label: 'Caribbean LX'
                },
                {
                    value: 'Caribbean RS',
                    label: 'Caribbean RS'
                },
                {
                    value: 'Caribbean Platinum',
                    label: 'Caribbean Platinum'
                },
                {
                    value: 'Classic LX',
                    label: 'Classic LX'
                },
                {
                    value: 'Classic DLX',
                    label: 'Classic DLX'
                },
                {
                    value: 'Classic Platinum',
                    label: 'Classic Platinum'
                },
                {
                    value: 'Continental',
                    label: 'Continental'
                },
                {
                    value: 'Continental NX',
                    label: 'Continental NX'
                },
                {
                    value: 'Savannah',
                    label: 'Savannah'
                },
                {
                    value: 'Not Sure',
                    label: 'Not Sure'
                }
            ]
        },
        nauticstar: {
            brandLogo: "NauticStar/ns_logo.png",
            brandName: "NauticStar",
            brandUrl: "https://nauticstarboats.com/",
            footerLogo: 'NauticStar/ns_logo.png',
            copyright: new Date().getFullYear() + " NauticStar, LLC. All rights reserved.",
            socialMedia: [{
                    icon: 'fa-facebook',
                    label: 'Facebook',
                    url: 'https://www.facebook.com/NauticStarBoats',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-instagram',
                    label: 'Instagram',
                    url: 'https://www.instagram.com/nauticstarboats',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-twitter',
                    label: 'Twitter',
                    url: 'https://twitter.com/nauticstarboats',
                    target: '_blank',
                    isActive: true
                },
                {
                    icon: 'fa-youtube',
                    label: 'Youtube',
                    url: 'https://www.youtube.com/c/NauticStarBoatsUSA',
                    target: '_blank',
                    isActive: true
                }
            ],
            header: [
                //{
                //    name: 'Inventory',
                //    link: '/inventory',
                //    target: 'self',
                //    isActive: true,
                //    dropdown: true,
                //    dropdownLinks: [
                //        { name: 'New Boats', link: '/Inventory/New', dropdown: false },
                //        { name: 'Used Boats', link: '/Inventory/Used', dropdown: false },
                //    ],
                //},
                {
                    name: 'Inventory',
                    link: '/Inventory/New',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Design a Boat',
                    link: 'https://build.nauticstarboats.com',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Trade-In',
                    link: '/Contact/TradeIn',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Parts & Service',
                    link: '/Contact/PartsService',
                    target: 'self',
                    isActive: true,
                    dropdown: false
                },
                {
                    name: 'Request Brochure',
                    link: '/Contact/RequestBrochure',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'News & Events',
                    link: '/newsevents',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Apparel',
                    link: 'https://apparel.nauticstarboats.com/',
                    target: '_blank',
                    isActive: true,
                    dropdown: false,
                },
                {
                    name: 'Contact Us',
                    link: '/Contact/ContactUs',
                    target: 'self',
                    isActive: true,
                    dropdown: false,
                }
            ],
            footer: [{
                    title: 'Sales/Service',
                    menubar: [{
                            name: 'Inventory',
                            link: '/Inventory/New',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        }, {
                            name: 'Design a Boat',
                            link: 'https://build.nauticstarboats.com',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        }, {
                            name: 'Trade-In',
                            link: '/Contact/TradeIn',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Parts & Service',
                            link: '/Contact/PartsService',
                            target: 'self',
                            isActive: true,
                            dropdown: false
                        },
                        {
                            name: 'Apparel',
                            link: 'https://apparel.nauticstarboats.com/',
                            target: '_blank',
                            isActive: true,
                            dropdown: false,
                        }
                    ]
                },
                {
                    title: 'Company',
                    menubar: [{
                            name: 'Request Brochure',
                            link: '/Contact/RequestBrochure',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'News & Events',
                            link: '/newsevents',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        },
                        {
                            name: 'Contact Us',
                            link: '/Contact/ContactUs',
                            target: 'self',
                            isActive: true,
                            dropdown: false,
                        }
                    ]
                }
            ],
            termCondition: [{
                    label: 'Terms & Conditions',
                    url: 'https://nauticstarboats.com/terms-of-use/',
                    target: 'self',
                    isActive: true
                },
                {
                    label: 'Privacy Policy',
                    url: 'https://nauticstarboats.com/privacy-policy/',
                    target: 'self',
                    isActive: true
                },
                // {
                    // label: 'Cookie Settings',
                    // url: 'javascript:showCookieBanner();',
                    // target: 'self',
                    // isActive: true
                // },
                {
                    label: 'Accessibility',
                    url: 'https://nauticstarboats.com/website-accessibility-statement/',
                    target: 'self',
                    isActive: true
                }
            ],
            models: [{
                    value: '195 XTS',
                    label: '195 XTS'
                },
                {
                    value: '215 XTS',
                    label: '215 XTS'
                },
                {
                    value: '215 XTS SB',
                    label: '215 XTS SB'
                },
                {
                    value: '227 XTS',
                    label: '227 XTS'
                },
                {
                    value: '249 XTS',
                    label: '249 XTS'
                },
                {
                    value: '191 Hybrid',
                    label: '191 Hybrid'
                },
                {
                    value: '211 Hybrid',
                    label: '211 Hybrid'
                },
                {
                    value: '231 Hybrid',
                    label: '231 Hybrid'
                },
                {
                    value: '251 Hybrid',
                    label: '251 Hybrid'
                },
                {
                    value: '193 SC',
                    label: '193 SC'
                },
                {
                    value: '203 SC',
                    label: '203 SC'
                },
                {
                    value: '203 DC',
                    label: '203 DC'
                },
                {
                    value: '223 DC',
                    label: '223 DC'
                },
                {
                    value: '243 DC',
                    label: '243 DC'
                },
                {
                    value: '2102 Legacy',
                    label: '2102 Legacy'
                },
                {
                    value: '2302 Legacy',
                    label: '2302 Legacy'
                },
                {
                    value: '2602 Legacy',
                    label: '2602 Legacy'
                },
                {
                    value: '24L',
                    label: '24L'
                },
                {
                    value: '24 XS',
                    label: '24 XS'
                },
                {
                    value: '28 XS',
                    label: '28 XS'
                }
            ]
        }
    }
    /**
     * 
     * @param {*} brand 
     * @param {*} key 
     * @returns 
     */
const getBrandDetails = (brand, key) => config[brand][key];
/**
 * 
 */
export default getBrandDetails;